import { useEffect } from "react";
import { shallowEqual, useLocation, useSelector } from "umi";
import { buriedPoint } from "./buriedPoint";
import { getPathFromDashboard } from "@/pages/dashboard/utils/utils";

/**
 * 打点hooks封装
 * @params params：打点信息
 */
export const useBuriedPoint = (params: any) => {
  const { pageId, pageName, extInfo, pagePath, uid, typeId = 'dashboard_pc_v2' } = params;
  const location = useLocation();
  const { menuId, path, gameCode } = useSelector(state => {
    return {
      menuId: state?.dashboard?.currentMenu?.id,
      path: state?.dashboard?.currentMenu?.path || '/' + getPathFromDashboard(state?.dashboard?.currentMenu),
      gameCode: state.dashboard?.currentGame?.game_code,
    }
  }, shallowEqual)

  useEffect(() => {
    // 修复菜单menuId异步获取打点错误
    if (!path || !gameCode) return
    if (!location?.pathname?.includes(`/${gameCode}${path}`)) return
    buriedPoint({ menuId, pageId, pageName, extInfo, pagePath, uid, typeId: typeId })
  }, [gameCode, menuId, path])
}
